/**
 * ========================================
 * TECH FEATURES POPUP FUNCTIONALITY
 * ========================================
 * Handles popup opening/closing and video playback
 */

(function() {
  'use strict';

  let currentPopup = null;

  /**
   * Open tech feature popup
   * @param {string} techId - Unique identifier for the tech feature
   */
  window.openTechPopup = function(techId) {
    const overlay = document.getElementById('techPopupOverlay');
    const popup = document.getElementById('techPopup-' + techId);

    if (!overlay || !popup) {
      console.warn('Tech popup or overlay not found for ID:', techId);
      return;
    }

    // Close any existing popup first
    if (currentPopup && currentPopup !== popup) {
      closeTechPopup();
    }

    // Show overlay
    overlay.classList.add('active');

    // Show popup with slight delay for smooth animation
    setTimeout(() => {
      popup.classList.add('active');
      currentPopup = popup;
    }, 10);

    // Prevent body scroll when popup is open
    document.body.style.overflow = 'hidden';
  };

  /**
   * Close currently open tech feature popup
   */
  window.closeTechPopup = function() {
    const overlay = document.getElementById('techPopupOverlay');

    if (!currentPopup) return;

    // Pause and reset video if exists
    const video = currentPopup.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
      video.removeAttribute('controls');
      
      const playButton = currentPopup.querySelector('.tech-video-play-button');
      if (playButton) {
        playButton.classList.remove('hidden');
      }
    }

    // Hide popup
    currentPopup.classList.remove('active');

    // Hide overlay with delay to match animation
    setTimeout(() => {
      if (overlay) {
        overlay.classList.remove('active');
      }
      currentPopup = null;
      document.body.style.overflow = '';
    }, 300);
  };

  /**
   * Toggle video play/pause
   * @param {string} techId - Unique identifier for the tech feature
   */
  window.toggleTechVideo = function(techId) {
    const video = document.getElementById('techVideo-' + techId);
    const playButton = document.getElementById('playButton-' + techId);

    if (!video || !playButton) {
      console.warn('Video or play button not found for ID:', techId);
      return;
    }

    if (video.paused) {
      video.play();
      video.setAttribute('controls', 'controls');
      playButton.classList.add('hidden');
    } else {
      video.pause();
      video.removeAttribute('controls');
      playButton.classList.remove('hidden');
    }
  };

  /**
   * Navigate to technology page
   * @param {Event} event - Click event
   * @param {string} techId - Unique identifier for the tech feature
   * @param {string} learnMoreUrl - URL to navigate to
   */
  window.navigateToTechPage = function(event, techId, learnMoreUrl) {
    event.preventDefault();
    
    // Store tech ID in session storage for potential use on destination page
    sessionStorage.setItem('openTechPopup', techId);
    
    // Open in new tab
    window.open(learnMoreUrl, '_blank');
  };

  /**
   * Initialize event listeners
   */
  function initTechFeatures() {
    // Close popup on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && currentPopup) {
        closeTechPopup();
      }
    });

    // Prevent clicks inside popup from closing it
    document.querySelectorAll('.tech-popup').forEach(function(popup) {
      popup.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    });

    // Add keyboard support for tech feature items
    document.querySelectorAll('.tech-feature-content').forEach(function(item) {
      item.addEventListener('keypress', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });

    // Video event listeners
    document.querySelectorAll('.tech-popup-media video').forEach(function(video) {
      // When video starts playing
      video.addEventListener('play', function() {
        const techId = this.id.replace('techVideo-', '');
        const playButton = document.getElementById('playButton-' + techId);
        if (playButton) {
          playButton.classList.add('hidden');
        }
      });

      // When video is paused
      video.addEventListener('pause', function() {
        const techId = this.id.replace('techVideo-', '');
        const playButton = document.getElementById('playButton-' + techId);
        
        // Hide native controls when paused
        this.removeAttribute('controls');
        
        // Show custom play button (only if video has been played)
        if (playButton && this.currentTime > 0) {
          playButton.classList.remove('hidden');
        }
      });

      // When video ends
      video.addEventListener('ended', function() {
        const techId = this.id.replace('techVideo-', '');
        const playButton = document.getElementById('playButton-' + techId);
        
        // Reset video
        this.currentTime = 0;
        this.removeAttribute('controls');
        
        // Show play button
        if (playButton) {
          playButton.classList.remove('hidden');
        }
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTechFeatures);
  } else {
    initTechFeatures();
  }
})();